import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';

import { EditNoteComponent } from './edit-note/edit-note.component';

downgradedAngularModule
  .directive('angularEditNote', downgradeComponent({ component: EditNoteComponent }));
